export default {
  'app.pwa.offline': 'Ҳоло шумо офлайн ҳастед',
  'app.pwa.serviceworker.updated': 'Мазмуни нав дастрас аст',
  'app.pwa.serviceworker.updated.hint': 'Лутфан тугмаи "Навсозӣ"-ро пахш кунед',
  'app.pwa.serviceworker.updated.ok': 'Навсозӣ',
};


